<template>
  <div style="width: 100%; background-color: #091017;">
    <footer class="container d-flex flex-wrap justify-content-between align-items-center py-3">

      <!-- Izquierda -->
      <div class="col-md-4 d-flex align-items-center">
        <span class="text-white fw-semibold" style="font-size: 1.1rem;">
          © 2025 Mitikuin
        </span>
      </div>

      <!-- Centro -->
      <ul class="nav mb-2">
        <li class="nav-item">
          <a 
            href="https://blog.mitikuin.com/" 
            class="nav-link px-2 text-white text-decoration-none"
            style="font-size: 1.2rem;"
          >
            Blog
          </a>
        </li>
      </ul>

      <!-- Derecha (redes) -->
      <ul class="nav col-md-4 justify-content-end list-unstyled d-flex mb-0">

        <!-- Instagram -->
        <li class="ms-3">
          <a href="https://www.instagram.com/Mitikuin/" target="_blank" aria-label="Instagram">
            <svg fill="#f7f7f7" height="23px" width="23px" viewBox="-271 273 256 256">
              <path d="M-64.5,273h-157c-27.3,0-49.5,22.2-49.5,49.5v157c0,27.3,22.2,49.5,49.5,49.5h157c27.3,0,49.5-22.2,49.5-49.5v-157 C-15.1,295.2-37.3,273-64.5,273z M-179.6,374.7c8.2-11.3,21.5-18.8,36.5-18.8s28.3,7.4,36.5,18.8c5.4,7.4,8.5,16.5,8.5,26.3 c0,24.8-20.2,45.1-45.1,45.1s-44.9-20.3-44.9-45.1C-188.1,391.2-184.9,382.1-179.6,374.7z"/>
            </svg>
          </a>
        </li>

        <!-- Facebook -->
        <li class="ms-3">
          <a href="https://www.facebook.com/Mitikuin" target="_blank" aria-label="Facebook">
            <svg fill="#e8e8e8" height="23px" width="23px" viewBox="-337 273 123.5 256">
              <path d="M-260.9,327.8c0-10.3,9.2-14,19.5-14c10.3,0,21.3,3.2,21.3,3.2l6.6-39.2c0,0-14-4.8-47.4-4.8c-20.5,0-32.4,7.8-41.1,19.3 c-8.2,10.9-8.5,28.4-8.5,39.7v25.7H-337V396h26.5v133h49.6V396h39.3l2.9-38.3h-42.2V327.8z"/>
            </svg>
          </a>
        </li>

        <!-- LinkedIn -->
        <li class="ms-3">
          <a href="https://www.linkedin.com/company/mitikuin" target="_blank" aria-label="LinkedIn">
            <svg fill="#e8e8e8" height="26px" width="26px" viewBox="0 0 448 512">
              <path d="M100.28 448H7.4V149.1h92.88zm-46.44-338C24.07 110 0 85.94 0 56.72A53.28 53.28 0 0 1 53.84 3.44a53.28 53.28 0 0 1 53.84 53.28c0 29.22-24.07 53.28-53.84 53.28zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.25-79.2-48.25 0-55.65 37.7-55.65 76.6V448h-92.68V149.1h88.98v40.8h1.3c12.4-23.6 42.64-48.25 87.76-48.25 93.8 0 111.1 61.8 111.1 142.3V448z"/>
            </svg>
          </a>
        </li>
      </ul>
      
    </footer>
    <p class="recaptcha-legal">
  Este sitio está protegido por reCAPTCHA y se aplican la
  <a href="https://policies.google.com/privacy" class="text-white">Política de Privacidad</a>
  y los
  <a href="https://policies.google.com/terms" class="text-white">Términos del Servicio</a>
  de Google.
</p>
  </div>
</template>
